import { getCampaignClosedReason } from "../api/campaignClosedReason";
import GenericDictionaryPage from "./GenericDictionaryPage";

export default function CampaignClosedReason() {
    return (
        <GenericDictionaryPage
            tableKey="campaignClosedReason"
            fetchData={getCampaignClosedReason}
            titleKey="genericDic:campaignClosedReason"
            newButtonLabel={({ t }) =>
                t("genericDic:campaignClosedReasonButtonNew", {
                    tableName: t("genericDic:campaignClosedReason").toLowerCase()
                })
            }
        /> 
    );
}
